import { setLocation } from "@/store/actions"
import store from "@/store/index"
import { trimEnd } from "lodash"

export async function initLocation() {
  try {
    if (store.getters.location !== null) return
    let rawLocation = await getLocation()
    setLocation({
      lng: rawLocation.position.lng,
      lat: rawLocation.position.lat,
      poiName: "当前定位",
      address: rawLocation.formattedAddress,
      detail: rawLocation.addressComponent
    })
  } catch (e) {
    console.warn("定位失败", e)
    if (e != "地址库未加载完成") setLocation({})
  }
}

/**
 * 浏览器定位
 */
async function getLocation() {
  return new Promise((resolve, reject) => {
    if (!window.AMap?.Geolocation) {
      reject("地址库未加载完成")
      return
    }
    if (window.qd__fromApp) {
      reject("app内无需请求定位")
      return
    }
    new window.AMap.Geolocation({
      enableHighAccuracy: true,
      timeout: 1000
    }).getCurrentPosition(function(status, result) {
      if (status == "complete") resolve(result)
      else reject(result)
    })
  })
}

export async function searchLocation(addressStr) {
  let searchResult = await searchPois(addressStr)
  let poi = searchResult.poiList?.pois?.[0]
  if (!poi) return null
  return {
    lng: poi.location.lng,
    lat: poi.location.lat,
    poiName: poi.name,
    address: poi.address
  }
}

async function searchPois(addressStr) {
  return new Promise((resolve, reject) => {
    new window.AMap.PlaceSearch({}).search(addressStr, function(status, result) {
      if (status == "complete") resolve(result)
      else reject(result)
    })
  })
}

/**
 * 计算两个定位之间距离
 * @returns 单位：米
 */
export function getDistance(lng1, lat1, lng2, lat2) {
  const AMap = window.AMap
  return AMap.GeometryUtil.distance(new AMap.LngLat(lng1, lat1), new AMap.LngLat(lng2, lat2))
}

export function getAreaString(detailAddress) {
  return [
    trimEnd(detailAddress.province, "省"),
    detailAddress.city,
    detailAddress.district,
    detailAddress.township
  ].join("-")
}
